import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {}
  },
  mutations: {
    setUserInfo(state, val) {
      state.userInfo = val
    },
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js